@if (bookings.length) {
  <div class="driver-bookings">
    @for (b of bookings; track b) {
      <div class="driver-booking-row" (click)="showBooking(b)">
        <div class="status">
          <div class="check" (click)="stop($event)">
            <app-check-off-passengers [booking]="b" [driverMode]="true" [direction]="topic"></app-check-off-passengers>
          </div>
          <div class="icons" [ngClass]="{ 'arrival': topic === 'arrival', 'departure': topic === 'departure' }">
            <mat-icon class="icon" [class.active]="wantsChildSafetySeat(b)" matTooltip="Barnsäkerhet">child_care</mat-icon>
            <mat-icon class="icon" [class.active]="hasDemand(b)" matTooltip="Betalning">credit_card</mat-icon>
            <!-- Remove hand-luggage in departures only -->
            @if (topic === 'arrival') {
              <mat-icon class="icon" [class.active]="carryOnOnly(b)"
              matTooltip="Handbagage">business_center</mat-icon>
            }
            @if (topic === 'departure') {
              <mat-icon class="icon return-flight-icon"
                [class.active]="isMissingReturnFlightNumber(b)"
              [matTooltip]="isMissingReturnFlightNumber(b) ? 'Flightnummer för hemresa saknas' : 'Flightnummer för hemresa registrerat'">flight</mat-icon>
            }
            <mat-icon class="icon" [class.active]="requiresKey(b)"
            matTooltip="Nyckel krävs (garage/tvätt/verkstad)">vpn_key</mat-icon>
            <mat-icon class="icon" [class.active]="hasComment(b)" matTooltip="Kommentar">chat_bubble</mat-icon>
          </div>
        </div>
        <div class="booking-info">
          <div class="main">
            <div class="reg"><mat-icon>directions_car</mat-icon><span>{{ b.registrationNumber }}</span>
            <span class="sep">|</span>
            <span>{{ b.departureDate | date:'HH:mm' }}</span></div>
          </div>
          <span class="qty">{{ b.qtyPersons }} st</span>
        </div>
      </div>
    }
  </div>
}